import { useT } from "../../i18n/I18nProvider";
import "./messages.nav";
import { useUnreadTexts } from "./queries";

/** Unread texts, in the sidebar. Nothing is drawn while there are none or the count is unknown. */
export function TextsBadge() {
  const t = useT();
  const unread = useUnreadTexts();
  const count = unread.data?.texts ?? 0;
  if (count === 0) return null;
  return (
    <span className="cc-nav__badge">
      <span aria-hidden="true">{count > 99 ? "99+" : count}</span>
      <span className="sr-only">{t("comms.texts.unreadBadge", { count })}</span>
    </span>
  );
}
